import script from "./TheTopbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TheTopbar.vue?vue&type=script&lang=ts&setup=true"

import "./TheTopbar.vue?vue&type=style&index=0&id=89dedf88&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89dedf88"]])

export default __exports__